import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-hint-sm.svg'
import _imports_1 from '@/assets/btn_close-r.svg'


const _withScopeId = n => (_pushScopeId("data-v-272bda92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-overflow-scroll jr-h-full" }
const _hoisted_2 = { class: "jr-bg-white jr-w-full jr-p-5 jr-pt-3 jr-rounded" }
const _hoisted_3 = {
  key: 0,
  class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-gray-dark jr-text-s-1" }, "時間帯", -1))
const _hoisted_5 = { class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark jr-mb-2.5" }, "曜日別", -1))
const _hoisted_7 = { class: "jr-flex jr-justify-start jr-w-full jr-mt-4" }
const _hoisted_8 = {
  key: 1,
  class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark jr-mb-2.5" }, "エリア来訪時の交通手段別", -1))
const _hoisted_10 = { class: "jr-flex jr-mt-4" }
const _hoisted_11 = { class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-0.5 jr-mb-5" }
const _hoisted_12 = { class: "jr-flex jr-items-center jr-mb-2.5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark" }, "来訪頻度別", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "hint"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "jr-flex jr-mt-4 jr-flex-wrap" }
const _hoisted_17 = {
  key: 2,
  class: "jr-pb-12"
}
const _hoisted_18 = { class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5 jr-mb-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s-2 jr-text-gray-dark jr-mb-2.5" }, "エリア来訪者の属性", -1))
const _hoisted_20 = { class: "jr-flex jr-flex-wrap jr-justify-start jr-w-full jr-mt-4" }
const _hoisted_21 = {
  key: 3,
  class: "jr-pb-4"
}
const _hoisted_22 = { class: "jr-border-b jr-border-dashed jr-border-blue-light-soft jr-pb-4.5" }
const _hoisted_23 = { class: "jr-py-5" }
const _hoisted_24 = { class: "jr-absolute jr-bg-gray-soft jr-left-0 jr-bottom-0 jr-py-4.5 jr-w-full jr-border-t jr-border-gray-medium" }
const _hoisted_25 = { class: "jr-pl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIHourRangePicker = _resolveComponent("UIHourRangePicker")!
  const _component_UICheckbox = _resolveComponent("UICheckbox")!
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createElementBlock("div", {
    "data-html2canvas-ignore": "true",
    class: "transition-width area-filter jr-fixed jr-right-0 jr-bg-gray-soft jr-pt-5 jr-pl-5 jr-pr-5 jr-z-20",
    style: _normalizeStyle({ width: (_ctx.minimum ? '64px' : '292px') })
  }, [
    _createElementVNode("figure", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["jr-flex jr-justify-end jr-overflow-scroll jr-bg-white", { 'jr-h-4/5': !_ctx.isSameDay }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.isSameDay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_UIHourRangePicker, {
                  modelValue: _ctx.selectedTimeRange,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTimeRange) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_UICheckbox, {
              icon: _ctx.isAllDaySelected ? 'tick' : 'minus',
              label: "全て選択",
              modelValue: _ctx.isAllDays,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAllDays) = $event)),
              onChange: _ctx.handleAllDaysChange
            }, null, 8, ["icon", "modelValue", "onChange"]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.week, (w, index) => {
                return (_openBlock(), _createBlock(_component_UICheckbox, {
                  key: w.name,
                  class: _normalizeClass({ 'jr-mr-8': index < _ctx.week.length - 1 }),
                  label: w.name,
                  modelValue: w.isSelected,
                  "onUpdate:modelValue": ($event: any) => ((w.isSelected) = $event),
                  onChange: _ctx.handleWeekChange
                }, null, 8, ["class", "label", "modelValue", "onUpdate:modelValue", "onChange"]))
              }), 128))
            ])
          ]),
          (!_ctx.isSameDay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_UICheckbox, {
                  icon: _ctx.isAllTransportationSelected ? 'tick' : 'minus',
                  label: "全て選択",
                  modelValue: _ctx.isAllTransportation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAllTransportation) = $event)),
                  onChange: _ctx.handleAllTransportationChange
                }, null, 8, ["icon", "modelValue", "onChange"]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transportations, (transportation, index) => {
                    return (_openBlock(), _createBlock(_component_UICheckbox, {
                      key: transportation.name,
                      class: _normalizeClass({ 'jr-mr-5': index < _ctx.transportations.length - 1 }),
                      label: transportation.name,
                      modelValue: transportation.isSelected,
                      "onUpdate:modelValue": ($event: any) => ((transportation.isSelected) = $event),
                      onChange: _ctx.handleTransportationChange
                    }, null, 8, ["class", "label", "modelValue", "onUpdate:modelValue", "onChange"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("button", {
                class: "jr-ml-2 jr-outline-0",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickHint && _ctx.onClickHint(...args)))
              }, _hoisted_15)
            ]),
            _createVNode(_component_UICheckbox, {
              icon: _ctx.isAllFrequenciesSelected ? 'tick' : 'minus',
              label: "全て選択",
              modelValue: _ctx.isAllFrequencies,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isAllFrequencies) = $event)),
              onChange: _ctx.handleAllFrequencyChange
            }, null, 8, ["icon", "modelValue", "onChange"]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencies, (frequency, index) => {
                return (_openBlock(), _createBlock(_component_UICheckbox, {
                  class: _normalizeClass(["jr-mb-4", { 'jr-mr-4.5': index < _ctx.frequencies.length - 1 }]),
                  modelValue: frequency.isSelected,
                  "onUpdate:modelValue": ($event: any) => ((frequency.isSelected) = $event),
                  key: frequency.name,
                  label: frequency.name,
                  onChange: _ctx.handleFrequencyChange
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "label", "onChange"]))
              }), 128))
            ])
          ]),
          (!_ctx.isSameDay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_UICheckbox, {
                    icon: _ctx.isAllAttributeSelected ? 'tick' : 'minus',
                    label: "全て選択",
                    modelValue: _ctx.isAllAttributes,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isAllAttributes) = $event)),
                    onChange: _ctx.handleAllAttributeChange
                  }, null, 8, ["icon", "modelValue", "onChange"]),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributes, (attr, index) => {
                      return (_openBlock(), _createBlock(_component_UICheckbox, {
                        class: _normalizeClass(["jr-mb-4", { 'jr-mr-4.5': index < _ctx.attributes.length - 1 }]),
                        modelValue: attr.isSelected,
                        "onUpdate:modelValue": ($event: any) => ((attr.isSelected) = $event),
                        key: attr.name,
                        label: attr.name,
                        onChange: _ctx.handleAttributeChange
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "label", "onChange"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSameDay)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_UICheckbox, {
                    label: "対象エリア内のログを非表示にする",
                    modelValue: _ctx.except,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.except) = $event)),
                    labelClasses: "jr-text-primary jr-text-s jr-font-bold jr-tracking-wide",
                    align: "top"
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2), [
        [_vShow, !_ctx.minimum]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_23, [
        _createVNode(_component_UIButton, {
          class: "jr-w-full jr-text-center jr-h-10 jr-leading-10 jr-text-sm jr-rounded",
          label: '適用',
          type: 'primary',
          onClick: _ctx.handleSearch
        }, null, 8, ["onClick"])
      ], 512), [
        [_vShow, !_ctx.minimum]
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "transition",
            style: _normalizeStyle({ transform: (_ctx.minimum ? 'rotate(180deg)' : 'rotate(0deg)') }),
            alt: "btn_close"
          }, null, 4)
        ])
      ])
    ])
  ], 4))
}